import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { 
  Container, 
  Typography, 
  Box, 
  Paper, 
  TextField, 
  Button, 
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Divider,
  IconButton,
  Tooltip
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from 'axios';
import welcomeImage from './img/welcome.png';

function App() {
  const [formData, setFormData] = useState({
    nome: '',
    telefone: '',
    id: null
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [visitantes, setVisitantes] = useState([]);
  const [loadingVisitantes, setLoadingVisitantes] = useState(true);
  const [dialogTitle, setDialogTitle] = useState('Cadastrar Novo Visitante');

  useEffect(() => {
    buscarVisitantes();
  }, []);

  const buscarVisitantes = async () => {
    try {
      const response = await axios.get('https://tibmacae.org.br/listar-visitantes.php');
      setVisitantes(response.data);
    } catch (error) {
      console.error('Erro ao carregar lista de visitantes:', error);
    } finally {
      setLoadingVisitantes(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      if (formData.id) {
        // Edição
        await axios.put(`https://tibmacae.org.br/editar-visitante.php?id=${formData.id}`, formData);
        setMessage('Visitante atualizado com sucesso!');
      } else {
        // Cadastro
        await axios.post('https://tibmacae.org.br/cadastro.php', formData);
        setMessage('Visitante cadastrado com sucesso!');
      }
      
      setFormData({
        nome: '',
        telefone: '',
        id: null
      });
      setOpenDialog(false);
      buscarVisitantes();
    } catch (error) {
      setMessage('Erro ao salvar visitante. Por favor, tente novamente.');
      console.error('Erro:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDialog = (visitante = null) => {
    if (visitante) {
      setFormData({
        nome: visitante.nome,
        telefone: visitante.telefone,
        id: visitante.id
      });
      setDialogTitle('Editar Visitante');
    } else {
      setFormData({
        nome: '',
        telefone: '',
        id: null
      });
      setDialogTitle('Cadastrar Novo Visitante');
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setFormData({
      nome: '',
      telefone: '',
      id: null
    });
    setMessage('');
    setDialogTitle('Cadastrar Novo Visitante');
  };

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir este visitante?')) {
      try {
        await axios.delete(`https://tibmacae.org.br/excluir-visitante.php?id=${id}`);
        setMessage('Visitante excluído com sucesso!');
        buscarVisitantes();
      } catch (error) {
        setMessage('Erro ao excluir visitante. Por favor, tente novamente.');
        console.error('Erro:', error);
      }
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundImage: `url(${welcomeImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        // padding: 3,
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1
        }
      }}
    >
      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 2 }}>
        <Paper 
          elevation={3} 
          sx={{ 
            p: 4, 
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(8px)',
            borderRadius: 2,
            padding: 0,
            paddingTop: 3,            
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
            border: '1px solid rgba(255, 255, 255, 0.2)'
          }}
        >
          <Typography 
            variant="h3" 
            component="h1" 
            sx={{ 
              fontFamily: "'Great Vibes', cursive",
              fontWeight: 700,
              color: '#FFFFFF',
              textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
              letterSpacing: '1px',
              textAlign: 'center',
              mb: 4,
              position: 'relative',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: '-10px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '100px',
                height: '3px',
                background: 'linear-gradient(90deg, transparent, #FFFFFF, transparent)',
              }
            }}
          >
            Sejam Bem Vindos
          </Typography>

          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleOpenDialog}
              sx={{ 
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 'bold',
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(4px)',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.3)',
                }
              }}
            >
              Cadastrar Novo Visitante
            </Button>
          </Box>

          <Divider sx={{ my: 3, borderColor: 'rgba(255, 255, 255, 0.2)' }} />

          <Typography 
            variant="h5" 
            sx={{ 
              fontFamily: "'Playfair Display', serif",
              fontWeight: 700,
              color: '#FFFFFF',
              textShadow: '1px 1px 3px rgba(0,0,0,0.5)',
              textAlign: 'center',
              mb: 3
            }}
          >
            Visitantes Cadastrados
          </Typography>

          {loadingVisitantes ? (
            <Box display="flex" justifyContent="center" p={3}>
              <CircularProgress sx={{ color: '#FFFFFF' }} />
            </Box>
          ) : (
            <List sx={{ 
              maxHeight: '40vh', 
              overflow: 'auto',
              '&::-webkit-scrollbar': {
                width: '8px',
              },
              '&::-webkit-scrollbar-track': {
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb': {
                background: 'rgba(255, 255, 255, 0.3)',
                borderRadius: '4px',
                '&:hover': {
                  background: 'rgba(255, 255, 255, 0.5)',
                },
              },
            }}>
              {visitantes.length > 0 ? (
                visitantes.map((visitante, index) => (
                  <ListItem 
                    key={index} 
                    divider
                    sx={{
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        transform: 'translateX(5px)',
                      },
                      padding: '16px 0',
                      // paddingLeft: '32px',
                      borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
                      display: 'flex',
                      justifyContent: 'space-between',
                      
                      alignItems: 'center'
                    }}
                  >
                    <ListItemText
                      primary={
                        <Typography 
                          variant="h6" 
                          sx={{ 
                            fontFamily: "'Playfair Display', serif",
                            fontWeight: 700,
                            color: '#FFFFFF',
                            letterSpacing: '0.5px',
                            marginBottom: '4px',
                            textShadow: '1px 1px 3px rgba(0,0,0,0.5)',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }}
                        >
                          {visitante.nome}
                        </Typography>
                      }
                      secondary={
                        <Typography 
                          variant="body1" 
                          sx={{ 
                            fontFamily: "'Dancing Script', cursive",
                            fontSize: '1.1rem',
                            color: 'rgba(255, 255, 255, 0.9)',
                            marginLeft: '8px',
                            textShadow: '1px 1px 2px rgba(0,0,0,0.5)'
                          }}
                        >
                          Telefone: {visitante.telefone}
                        </Typography>
                      }
                    />
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <Tooltip title="Editar">
                        <IconButton 
                          onClick={() => handleOpenDialog(visitante)}
                          sx={{ 
                            color: 'rgba(255, 255, 255, 0.7)',
                            '&:hover': {
                              color: '#FFFFFF',
                              backgroundColor: 'rgba(255, 255, 255, 0.1)'
                            }
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Excluir">
                        <IconButton 
                          onClick={() => handleDelete(visitante.id)}
                          sx={{ 
                            color: 'rgba(255, 255, 255, 0.7)',
                            '&:hover': {
                              color: '#FF6B6B',
                              backgroundColor: 'rgba(255, 107, 107, 0.1)'
                            }
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </ListItem>
                ))
              ) : (
                <Typography 
                  align="center" 
                  sx={{ 
                    color: 'rgba(255, 255, 255, 0.8)',
                    fontFamily: "'Dancing Script', cursive",
                    fontSize: '1.2rem',
                    textShadow: '1px 1px 2px rgba(0,0,0,0.5)'
                  }}
                >
                  Nenhum visitante cadastrado ainda.
                </Typography>
              )}
            </List>
          )}

          <Dialog 
            open={openDialog} 
            onClose={handleCloseDialog}
            PaperProps={{
              sx: {
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                backdropFilter: 'blur(10px)',
                borderRadius: 2,
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
              }
            }}
          >
            <DialogTitle sx={{ 
              fontFamily: "'Playfair Display', serif",
              fontWeight: 700,
              color: '#5D4037',
              textAlign: 'center'
            }}>
              {dialogTitle}
            </DialogTitle>
            <DialogContent>
              <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      required
                      fullWidth
                      label="Nome"
                      name="nome"
                      value={formData.nome}
                      onChange={handleChange}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: 'rgba(93, 64, 55, 0.5)',
                          },
                          '&:hover fieldset': {
                            borderColor: 'rgba(93, 64, 55, 0.8)',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#5D4037',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          color: 'rgba(93, 64, 55, 0.7)',
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                          color: '#5D4037',
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      // required
                      fullWidth
                      label="Telefone"
                      name="telefone"
                      value={formData.telefone}
                      onChange={handleChange}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: 'rgba(93, 64, 55, 0.5)',
                          },
                          '&:hover fieldset': {
                            borderColor: 'rgba(93, 64, 55, 0.8)',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#5D4037',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          color: 'rgba(93, 64, 55, 0.7)',
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                          color: '#5D4037',
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
              <Button 
                onClick={handleCloseDialog}
                sx={{ 
                  color: 'rgba(93, 64, 55, 0.7)',
                  '&:hover': {
                    backgroundColor: 'rgba(93, 64, 55, 0.1)',
                  }
                }}
              >
                Cancelar
              </Button>
              <Button 
                onClick={handleSubmit} 
                variant="contained"
                disabled={loading}
                sx={{ 
                  backgroundColor: '#5D4037',
                  '&:hover': {
                    backgroundColor: '#4E342E',
                  }
                }}
              >
                {loading ? <CircularProgress size={24} /> : 'Salvar'}
              </Button>
            </DialogActions>
            {message && (
              <Typography 
                align="center" 
                sx={{ 
                  p: 2, 
                  color: message.includes('sucesso') ? '#4CAF50' : '#F44336',
                  fontFamily: "'Dancing Script', cursive",
                  fontSize: '1.2rem'
                }}
              >
                {message}
              </Typography>
            )}
          </Dialog>
        </Paper>
      </Container>
    </Box>
  );
}

export default App; 